"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCalculator = void 0;
const annuity_1 = require("./annuity");
const insurance_1 = require("./insurance");
const trust_1 = require("./trust");
exports.PaymentCalculator = {
    calculateInsurance: insurance_1.calculateInsurancePaymentOptions,
    calculateTrust: trust_1.calculateTrustPaymentOptions,
    calculateAnnuity: annuity_1.calculateAnnuityPaymentOptions,
};
//# sourceMappingURL=payment-calculator.js.map